<template>
  <div ref="floatButton" class="float-info" :style="{ width: itemWidth + 'px', height: itemHeight + 'px', left: left + 'px', top: top + 'px' }" @click="onBtnClick">
    <a-button type="primary" shape="circle" @click="onBtnClick">
      <a-icon type="plus" />
    </a-button>
  </div>
</template>

<script>
export default {
  name: 'FloatButton',
  props: {
    itemWidth: {
      type: Number,
      default: 55
    },
    itemHeight: {
      type: Number,
      default: 55
    },
    gapWidth: {
      type: Number,
      default: 15
    },
    coefficientHeight: {
      type: Number,
      default: 0.55
    }
  },
  data() {
    return {
      clientWidth: 0, // 页面宽度
      clientHeight: 0, // 页面高度
      timer: null,
      currentTop: 0,
      left: 0,
      top: 0
    };
  },
  watch: {
    clientWidth: {
      immediate: true,
      handler(val) {
        if (!this.timer) {
          this.clientWidth = val;
          this.timer = true;
          const that = this;
          setTimeout(function() {
            that.left = that.clientWidth - (that.clientWidth - 1000) / 2 + that.gapWidth;
            that.top = that.clientHeight * that.coefficientHeight;
            that.timer = false;
          }, 50);
        }
      }
    }
  },
  created() {
    this.clientWidth = document.documentElement.clientWidth;
    this.clientHeight = document.documentElement.clientHeight;
    this.left = this.clientWidth - (this.clientWidth - 1000) / 2 + this.gapWidth;
    this.top = this.clientHeight * this.coefficientHeight;
  },
  mounted() {
    const that = this;
    window.onresize = () => {
      return (() => {
        that.clientWidth = document.body.clientWidth;
        that.clientHeight = document.documentElement.clientHeight;
      })();
    };
  }
};
</script>

<style lang="less" scoped>
.float-info {
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
  position: fixed;
  bottom: 50px;
  right: 30px;
  width: 55px;
  height: 55px;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  z-index: 999;
  background: #1e69eb;
  border-radius: 50%;
  cursor: pointer;
}
</style>
